import Popper from '@mui/material/Popper';
import { styled } from '@mui/material/styles';

const CustomPopper = styled(Popper)(() => ({
  '& .MuiAutocomplete-paper': {
    minWidth: 350,
    maxWidth: 900,
    marginLeft: '-300px',  
    whiteSpace: 'normal',
    overflowWrap: 'break-word',
    wordBreak: 'break-word',
  },
}));

export default CustomPopper;